import {DeepLinkActionBase} from '../deep-link-action-base';
import {OpenMembershipResponse} from '../../../external-links/external-links.service.interface';
import {CashierDeepLinkAction} from '../cashier/cashier-deeplink-action';
import {IDeepLinkActionChain} from '../deep-link-action-chain';
import {PlayGameRealDeepLinkAction} from '../play-game/play-game-real/play-game-real-deeplink-action';
import {PlayGameDemoDeepLinkAction} from '../play-game/play-game-demo/play-game-demo-deeplink-action';
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core/lib/apps/app-enums";

export class RegisterDeepLinkAction extends DeepLinkActionBase {

  async execute(): Promise<void> {

    let response = await this.services.externalLinks.openMembership(this.descriptor.marketingParams, true);

    switch(response) {
      case OpenMembershipResponse.deposit:
        return this._openCashier();
      case OpenMembershipResponse.play:
        return this._playGame();
    }
  }

  private _openCashier(): Promise<void> {
    let cashierAction = this._findNextActionOfType(CashierDeepLinkAction);
    if(cashierAction) {
      return cashierAction.execute();
    } else {
      return this.services.cashier.openCashier({
        channel: {
          source: CHANNEL_SOURCE.registration,
          area: AreaType.StraightToCashier,
          element: CHANNEL_ELEMENTS.depositButton
        }
      }, this.descriptor.marketingParams, true);
    }
  }

  private _findNextActionOfType(actionType: any): IDeepLinkActionChain | null {
    let next = this.nextAction;
    while(next) {
      if(this.services.deepLinkActionsFactory.isActionOfType(next, actionType)) {
        return next;
      } else {
        next = next.nextAction;
      }
    }

    return null;
  }

  private _playGame() {
    let nextAction = this._findNextActionOfType(PlayGameRealDeepLinkAction);
    if(nextAction) {
      return nextAction.execute();
    }

    nextAction = this._findNextActionOfType(PlayGameDemoDeepLinkAction);
    if(nextAction) {
      return nextAction.execute();
    }
    return Promise.resolve();
  }
}
